// extracted by mini-css-extract-plugin
export var shake = "_1q-0";